import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./routes/Router";
import { Toaster } from "./components/ui";

function App() {
  return (
    <BrowserRouter>
      <Router />
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
